import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import "./map-vender.scss";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import _ from "lodash";
import NoAccessPage from "@components/common/NoAccess";
import SelfComplianceTaskNavigation from "@components/Tasks/task-self-compliance-navigation";
import {
  SelfComplainceTaskUploadDocument,
  SelfComplainceUpdateStatusToReportedNonComplied,
  UpdateMultipleSelfComplianceTask,
  UpdateSelfComplianceTask,
  getSelfComplianceTaskInterlinkedTasks,
  getSpecificSelfComplianceTask,
  getSpecificSelfComplianceTaskEvaluator,
  getSpecificSelfComplianceTaskExecutor,
  updateSelfComplianceAuditorComment,
} from "@services/self-compliance.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { getEntityGroups } from "@services/entity-mapping.service";
import TaskDetailsCommon from "@components/common/TaskDetails";
import OrganizationInformationCommon from "@pages/Activities/OrgInfoCommon";
import { clientAdminFileUpload } from "@services/client-list.service";
import { toast } from "react-toastify";
import { convertDate, NewDate } from "@_common/date-helpers";
import { useNavigate } from "react-router-dom";
import SelfComplianceUpdatePopup from "../UpdateTaskPopup";
import { getDocumentCheckpoint } from "@services/checkpoint.service";
import ConfirmModalTask from "@_common/ConfirmModalTask";
import AuditorCommentModal from "../AuditorCommentPopup";

export default function SelfComplianceTaskDetailsPage(props: any) {
  let mainParams = useParams();
  const navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({});
  const [interlinkedTaskList, setInterlinkedTaskList] = useState<any>(null);
  const [docStoreData, setDocStoreData] = useState<any>([]);
  const [request, setRequest] = useState<any>({
    follow_up_date: "",
    renewal_reminder_date: "",
    expiry_date: "",
    completion_date: "",
    work_status: "",
    license_number: "",
    license_status: "",
    non_compliance_reason: "",
    evaluator_comments: "",
    is_no_expiry_task: false,
    document_ids: [
      {
        id: "",
      },
    ],
  });
  const [selectedStatus, setSelectedStatus] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [limit, setLimit] = useState(100);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getHeaderList();
    }
    let userInfo = getValue(localStorage, `user`, {});
    let user = JSON.parse(userInfo);
    if (getValue(user, `id`, "")) {
      setUserInfo(user);
    }
  }, [props.permissionAPITriggered]);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getHeaderList();
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    try {
      setLoading(true);
      let resp;
      if (route[3] === "my-task") {
        resp = await getSpecificSelfComplianceTaskExecutor(mainParams.id);
      } else if (route[3] === "pending-approval") {
        resp = await getSpecificSelfComplianceTaskEvaluator(mainParams.id);
      } else {
        resp = await getSpecificSelfComplianceTask(mainParams.id);
      }

      if (resp) {
        setData(getValue(resp, `data`, {}));

        if (resp?.data?.self_compliance?.interlinked_checkpoint?.id) {
          getInterlinkedTasks();
        }

        setRequest({
          ...request,
          follow_up_date: getValue(resp, `data.follow_up_date`, "")
            ? new Date(getValue(resp, `data.follow_up_date`, ""))
            : null,
          completion_date: getValue(resp, `data.completion_date`, "")
            ? new Date(getValue(resp, `data.completion_date`, ""))
            : null,
          expiry_date: getValue(resp, `data.expiry_date`, "")
            ? new Date(getValue(resp, `data.expiry_date`, ""))
            : null,
          compliance_status: getValue(resp, `data.compliance_status`, ""),
          license_number: getValue(resp, `data.license_number`, ""),
          work_status: getValue(resp, `data.work_status`, ""),
          license_status: getValue(resp, `data.license_status`, ""),
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            "",
          ),
          is_no_expiry_task: getValue(resp, `data.is_no_expiry_task`, false),
          document_ids: getValue(resp, `documents`, []),
        });
        setLoading(false);

        let getDocStorepayload: any = {
          checkpoint_id: getValue(
            resp,
            `data.self_compliance.checkpoint.checkpoint_id`,
            [],
          ),
          // page_no: params.page_no ? parseInt(params.page_no) : 1,
          // page_size: params.limit ? parseInt(params.limit) : limit,
          // search_text: params.search_text,
          // sort_by: params.sort_by,
        };
        let docStoreResp = await getDocumentCheckpoint(getDocStorepayload);
        if (docStoreResp) {
          setDocStoreData(getValue(docStoreResp, `data.checkpoints`, []));
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const [headerObj] = useState<any>({});
  const getHeaderList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        getValue(resp, `data.entityGroups`, []).map((item: any) => {
          return (headerObj[`level_${getValue(item, `group_level`, "")}`] =
            getValue(item, `group_name`, ""));
        });
      }
    } catch (error) { }
  };

  const getPayload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    const odf = params.owner_due_date_from;
    const odt = params.owner_due_date_to;
    const fd = params.from_date;
    const td = params.to_date;
    let dates = params.date ? new Date(params.date) : new Date();

    let from_date = fd
      ? fd
      : odf
        ? odf
        : convertDate(new Date(dates.getFullYear(), dates.getMonth(), 1));
    let to_date = td
      ? td
      : odt
        ? odt
        : convertDate(new Date(dates.getFullYear(), dates.getMonth() + 1, 0));

    let payload: any = {
      from_date: getValue(params, `is_all_time`, "") ? "" : from_date,
      to_date: getValue(params, `is_all_time`, "") ? "" : to_date,
    };
    return { ...payload };
  };

  const getRequestFrom = () => {
    const urlRoute = route[3];
    switch (urlRoute) {
      case "my-task":
        return "MY_TASKS";
      case "pending-approval":
        return "PENDING_APPROVAL";
      case "approved-task":
        return "APPROVED_TASK";
      case "master":
        return "MASTER";
      case "function-head":
        return "FUNCTION_HEAD";
      case "evaluator":
        return "EVALUATOR";
      default:
        return "";
    }
  };

  const getInterlinkedTasks = async () => {
    let payload = await getPayload();
    payload.request_from = getRequestFrom();
    payload.status = "active";
    let queryRequest = QueryRequestHelper(payload);
    const res = await getSelfComplianceTaskInterlinkedTasks(
      mainParams.id,
      queryRequest,
    );
    if (res?.data?.length > 0) setInterlinkedTaskList(res?.data);
  };

  /* ---------------------------  Update Modal  ----------------------------- */
  const [selectedId, setSelectedId] = useState("");
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selfCompliance, setSelfCompliance] = useState<any>({
    completion_date: "",
    compliance_status: "",
    work_status: "",
    remarks: "",
    non_compliance_reason: "",
    event_not_occured: false,
    document_ids: [],
    evaluator_comments: "",
  });
  const [complianceStatusList] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "PENDING_FOR_APPROVAL", label: "Pending For Approval" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
  ]);

  const [selectedInterlinkedIds, setSelectedInterlinkedIds] = useState<any>([]);

  const compareOnlyDates = (date1: any, date2: any) => {
    const d1 = new Date(new Date(date1).toDateString());
    const d2 = new Date(new Date(date2).toDateString());

    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
  };

  const handleSubmitTask = async (status: string, interlinkedIds?: any[]) => {
    setSelectedInterlinkedIds(interlinkedIds);
    let url = window.location.pathname.split("/");
    const urlSearchParams = new URLSearchParams(window.location.search);

    const currentISTDate = new Date().toDateString();

    const completionDate = selfCompliance.completion_date
      ? new Date(selfCompliance.completion_date).toDateString()
      : null;

    const legalDueDate = data.legal_due_date
      ? new Date(data.legal_due_date).toDateString()
      : null;

    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = { ...params };
    let queryRequest = QueryRequestHelper(payload);

    if (!completionDate) {
      toast.error("Completion date is mandatory");
      return;
    }

    setSelectedStatus(status);

    try {
      let obj = JSON.parse(JSON.stringify(selfCompliance));

      if (obj.completion_date) {
        obj.completion_date = convertDate(new Date(obj.completion_date));
      }

      if (status === "COMPLIED" || status === "RE_OPENED") {
        obj.compliance_status = status;
      } else {
        obj.approval_status = "APPROVED";
      }

      obj.document_ids =
        selfCompliance.document_ids?.length > 0
          ? selfCompliance.document_ids.map((item: object) => ({
            id: getValue(item, `id`, ""),
          }))
          : [];

      const isDocumentRequired = getValue(
        data,
        `self_compliance.document_required`,
        false,
      );
      const hasRequiredDocuments = selfCompliance.document_ids?.length > 0;
      const eventNotOccurred = selfCompliance.event_not_occured;
      const isLateCompletion =
        completionDate && legalDueDate
          ? compareOnlyDates(completionDate, legalDueDate) === 1
          : false;

      const isLateReporting = legalDueDate
        ? compareOnlyDates(currentISTDate, legalDueDate) === 1
        : false;
      const isReasonRequiredForEventNotOccurred =
        eventNotOccurred &&
        isLateReporting &&
        getValue(
          selfCompliance,
          `is_required_reason_for_non_compliance`,
          false,
        );

      // ------------------------------------------------

      const isMyTask = url[3] === "my-task";
      const nonComplianceReason = String(
        selfCompliance.non_compliance_reason || "",
      ).trim();
      const evaluatorComments = String(
        selfCompliance.evaluator_comments || "",
      ).trim();

      if (url[3] === "pending-approval" && isLateReporting && !evaluatorComments) {
        toast.error("Please provide Evaluator Comments");
        return;
      }

      if (isReasonRequiredForEventNotOccurred && !nonComplianceReason) {
        toast.error(
          "Please provide a reason for Non-Compliance when the event did not occur",
        );
        return;
      }

      if (isDocumentRequired && !hasRequiredDocuments && !eventNotOccurred) {
        toast.error("Documents required");
        return;
      }

      if (!selfCompliance.event_not_occured) {
        // SCENARIO 1: BOTH COMPLETION & REPORTING LATE
        if (isLateCompletion && isLateReporting) {
          if (isMyTask && !nonComplianceReason) {
            toast.error(
              "Completion Date is after Legal Due Date! Please provide Reason for Non-Compliance",
            );
            return;
          }
          if (!isMyTask && !evaluatorComments && status !== "RE_OPENED") {
            toast.error(
              "Completion Date and Reported Date are after Legal Due Date! Please provide comments",
            );
            return;
          }
        }
        // SCENARIO 2: COMPLETION ON TIME BUT REPORTING LATE
        else if (!isLateCompletion && isLateReporting) {
          if (isMyTask && !nonComplianceReason) {
            toast.error(
              "The Reported Date is after Legal Due Date! Please provide Reason for Non-Compliance",
            );
            return;
          }
        }
        // SCENARIO 3: ON TIME
        else {
          console.log("SCENARIO 3: On-time Task Completionss");
        }
      }

      // CONFIRMATION IF COMPLETION IS LATE
      if (
        isLateCompletion &&
        status !== "RE_OPENED" &&
        !selfCompliance.event_not_occured
      ) {
        handleConfirmModal();
        return;
      }

      // API CALL
      setSubmitLoading(true);
      let resp;

      if (interlinkedIds && interlinkedIds.length > 1) {
        obj.self_compliance_task_ids = interlinkedIds;
        resp = await UpdateMultipleSelfComplianceTask(obj);
      } else {
        resp = await UpdateSelfComplianceTask(
          getValue(mainParams, `id`, ""),
          obj,
        );
      }

      if (resp) {
        setSelectedInterlinkedIds([]);
        toast.success(getValue(resp, `message`, ""));
        setSubmitLoading(false);
        setShowUpdatePopup(false);
        setSelfCompliance({
          completion_date: "",
          compliance_status: "",
          work_status: "",
          remarks: "",
          non_compliance_reason: "",
          event_not_occured: false,
          document_ids: [],
          evaluator_comments: "",
        });
        navigate(
          `/${getValue(url, `[1]`, "")}/${getValue(url, `[2]`, "")}/${getValue(
            url,
            `[3]`,
            "",
          )}?${queryRequest}`,
        );
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      console.error("Error submitting task:", error);
      setSubmitLoading(false);
      toast.error("Failed to submit task");
    }
  };

  const getDateOnly = (date: Date) => new Date(date.toDateString()); // removes time completely

  const handleSubmitConfirmModalTask = async () => {
    let url = window.location.pathname.split("/");
    const urlSearchParams = new URLSearchParams(window.location.search);

    // Generate current IST date (without time)
    const currentISTDate = getDateOnly(new Date());

    // Convert stored timestamps → JS Date → remove time
    const completionDate = selfCompliance.completion_date
      ? getDateOnly(new Date(selfCompliance.completion_date))
      : null;

    const legalDueDate = data.legal_due_date
      ? getDateOnly(new Date(data.legal_due_date))
      : null;

    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = { ...params };
    let queryRequest = QueryRequestHelper(payload);

    if (!completionDate) {
      toast.error("Completion date is mandatory");
      return;
    }

    try {
      let obj = JSON.parse(JSON.stringify(selfCompliance));

      if (obj.completion_date) {
        obj.completion_date = convertDate(new Date(obj.completion_date));
      }

      if (selectedStatus === "COMPLIED" || selectedStatus === "RE_OPENED") {
        obj.compliance_status = selectedStatus;
      } else {
        obj.approval_status = "APPROVED";
      }

      obj.document_ids =
        selfCompliance.document_ids?.length > 0
          ? selfCompliance.document_ids.map((item: object) => ({
            id: getValue(item, `id`, ""),
          }))
          : [];

      const isDocumentRequired = getValue(
        data,
        `self_compliance.document_required`,
        false,
      );

      const hasRequiredDocuments = selfCompliance.document_ids?.length > 0;
      const eventNotOccurred = selfCompliance.event_not_occured;

      const completionDateIST = completionDate;
      const legalDueDateIST = legalDueDate;
      const reportedDateIST = currentISTDate;

      // Date-only comparisons
      const isLateCompletion =
        completionDateIST && legalDueDateIST
          ? completionDateIST.getTime() > legalDueDateIST.getTime()
          : false;

      const isLateReporting = legalDueDateIST
        ? reportedDateIST.getTime() > legalDueDateIST.getTime()
        : false;

      const isMyTask = route[3] === "my-task";
      const nonComplianceReason = String(
        selfCompliance.non_compliance_reason || "",
      ).trim();
      const evaluatorComments = String(
        selfCompliance.evaluator_comments || "",
      ).trim();

      if (isDocumentRequired && !hasRequiredDocuments && !eventNotOccurred) {
        toast.error("Documents required");
        return;
      }

      // -------- SCENARIOS ----------
      if (isLateCompletion && isLateReporting) {
        if (isMyTask && !nonComplianceReason) {
          toast.error(
            "The Completion Date is greater than Legal Due Date! Please provide Reason for Non-Compliance",
          );
          return;
        }
        if (
          !isMyTask &&
          !evaluatorComments &&
          isLateReporting &&
          selectedStatus !== "RE_OPENED"
        ) {
          toast.error(
            "Completion Date and Reported Date are after Legal Due Date! Please provide your comments",
          );
          return;
        }
      } else if (!isLateCompletion && isLateReporting) {
        if (isMyTask && !nonComplianceReason) {
          toast.error(
            "The Reported Date is after Legal Due Date! Please provide Reason for Non-Compliance",
          );
          return;
        }
        if (
          !isMyTask &&
          !evaluatorComments &&
          isLateReporting &&
          selectedStatus !== "RE_OPENED"
        ) {
          toast.error(
            "The Reported Date is after Legal Due Date! Please provide your comments",
          );
          return;
        }
      } else {
        // On-time, nothing required
      }

      // ------ SUBMIT ------
      setSubmitLoading(true);

      let resp;
      if (selectedInterlinkedIds && selectedInterlinkedIds.length > 1) {
        obj.self_compliance_task_ids = selectedInterlinkedIds;
        resp = await UpdateMultipleSelfComplianceTask(obj);
      } else {
        resp = await UpdateSelfComplianceTask(
          getValue(mainParams, `id`, ""),
          obj,
        );
      }

      if (resp) {
        setSelectedInterlinkedIds([]);
        toast.success(getValue(resp, `message`, ""));
        setSubmitLoading(false);
        setShowUpdatePopup(false);
        setConfirmOpen(false);

        setSelfCompliance({
          completion_date: "",
          compliance_status: "",
          work_status: "",
          remarks: "",
          non_compliance_reason: "",
          event_not_occured: false,
          document_ids: [],
          evaluator_comments: "",
        });

        navigate(
          `/${getValue(url, `[${1}]`, "")}/${getValue(
            url,
            `[${2}]`,
            "",
          )}/${getValue(url, `[${3}]`, "")}?${queryRequest}`,
        );
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      console.error("Error confirming task:", error);
      setSubmitLoading(false);
      toast.error("Failed to confirm task");
    }
  };

  const handleUploadSubmitTask = async (status: string) => {
    let url = window.location.pathname.split("/");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const completionDate = new Date(
      getValue(selfCompliance, `completion_date`, ""),
    );
    const legalDueDate = new Date(getValue(data, `legal_due_date`, ""));

    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    if (getValue(selfCompliance, `completion_date`, "")) {
      setSelectedStatus(status);
      try {
        let obj = JSON.parse(JSON.stringify(selfCompliance));
        // const completionDateUTC = new Date(obj["completion_date"]);
        // const istDate = new Date(
        //   completionDateUTC.getTime() + 5.5 * 60 * 60 * 1000
        // );
        // obj["completion_date"] = `${istDate.getFullYear()}-${(
        //   istDate.getMonth() + 1
        // )
        //   .toString()
        //   .padStart(2, "0")}-${istDate
        //   .getDate()
        //   .toString()
        //   .padStart(2, "0")}T${istDate
        //   .getHours()
        //   .toString()
        //   .padStart(2, "0")}:${istDate
        //   .getMinutes()
        //   .toString()
        //   .padStart(2, "0")}:${istDate
        //   .getSeconds()
        //   .toString()
        //   .padStart(2, "0")}`;

        if (status === "COMPLIED" || status === "RE_OPENED") {
          obj["compliance_status"] = status;
        } else {
          obj["approval_status"] = "APPROVED";
        }
        obj["document_ids"] =
          getValue(selfCompliance, `document_ids.length`, 0) > 0
            ? getValue(selfCompliance, `document_ids`, []).map(
              (item: object) => ({ id: getValue(item, `id`, "") }),
            )
            : [];

        obj["completion_date"] = new Date().toISOString();
        const isDocumentRequired = getValue(
          data,
          `self_compliance.document_required`,
          false,
        );
        const hasRequiredDocuments =
          getValue(selfCompliance, `document_ids.length`, 0) > 0;
        const eventNotOccurred = getValue(
          selfCompliance,
          `event_not_occured`,
          false,
        );
        const isLateCompletion = completionDate > legalDueDate;
        const isLateReporting = compareOnlyDates(new Date(), legalDueDate) === 1;
        const isMyTask = route[3] === "my-task";
        const nonComplianceReason = String(
          getValue(selfCompliance, `non_compliance_reason`, "") || "",
        ).trim();
        const evaluatorComments = String(
          getValue(selfCompliance, `evaluator_comments`, "") || "",
        ).trim();
        // Check if documents are required but not provided, and event hasn't occurred
        if (isDocumentRequired && !hasRequiredDocuments && !eventNotOccurred) {
          toast.error("Documents required");
        }
        // Check if completion date is late and relevant comments are missing
        else if (isLateCompletion && isMyTask && !nonComplianceReason) {
          toast.error(
            "The Completion Date is greater than Legal Due Date! Please provide your Reason for Non-Compliance",
          );
        } else if (
          isLateCompletion &&
          !isMyTask &&
          !evaluatorComments &&
          isLateReporting &&
          !eventNotOccurred
        ) {
          toast.error(
            "The Completion Date is greater than Legal Due Date! Please provide your comments",
          );
        } else {
          // if (isLateCompletion) {
          //   handleConfirmModal();
          // } else {
          setSubmitLoading(true);
          let resp = await UpdateSelfComplianceTask(
            getValue(mainParams, `id`, ""),
            obj,
          );
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setSubmitLoading(false);
            setShowUpdatePopup(false);
            setSelfCompliance({
              ...selfCompliance,
              completion_date: "",
              compliance_status: "",
              work_status: "",
              remarks: "",
              non_compliance_reason: "",
              event_not_occured: false,
              document_ids: [],
            });
            navigate(
              `/${getValue(url, `[${1}]`, "")}/${getValue(
                url,
                `[${2}]`,
                "",
              )}/${getValue(url, `[${3}]`, "")}?${queryRequest}`,
            );
          } else {
            setSubmitLoading(false);
          }
          // }
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Completion date is mandatory");
    }
  };

  const handleClickPopup = () => {
    let obj = data;
    const filteredDocuments = getValue(obj, "documents", []).filter(
      (doc: any) => !doc.key,
    );
    const reason = getValue(data, "non_compliance_reason", "")?.trim();

    const result =
      reason === "System movement to Non-Complied as legal due date expires"
        ? ""
        : reason;
    setShowUpdatePopup(!showUpdatePopup);
    setSelectedId(getValue(obj, `id`, ""));
    setSelfCompliance({
      ...selfCompliance,
      completion_date: getValue(obj, `completion_date`, null)
        ? NewDate(getValue(obj, `completion_date`, null))
        : null,
      compliance_status: getValue(obj, `compliance_status`, null),
      work_status: getValue(obj, `work_status`, null),
      remarks: getValue(obj, `remarks`, null),
      non_compliance_reason: result,
      evaluator_comments: getValue(obj, `evaluator_comments`, null),
      event_not_occured: getValue(obj, `event_not_occured`, false),
      // document_ids: filteredDocuments,
      document_ids: getValue(obj, `documents`, []),
    });
  };

  /* -------------------------  Upload Document  ------------------------------ */
  const [uploadLoading, setUploadLoading] = useState(false);
  const removeDocument = (id: string) => {
    let filtered =
      getValue(selfCompliance, `document_ids.length`, 0) > 0
        ? getValue(selfCompliance, `document_ids`, []).filter(
          (item: any) => item.id !== id,
        )
        : [];
    setSelfCompliance({
      ...selfCompliance,
      document_ids: filtered,
    });

    // const currentDocuments = getValue(selfCompliance, `document_ids`, []);
    // console.log('Current Documents:', currentDocuments);

    // const filtered = currentDocuments.filter((item: any) => item.id !== id);
    // console.log('Filtered Documents:', filtered);

    // setSelfCompliance((prevState:any) => (
    //   console.log(prevState),{
    //   ...prevState,
    //   document_ids: filtered,
    // }));

    // setSelfCompliance((prevState: any) => {
    //   console.log('Previous State:', prevState);

    //   // Filter the documents based on the ID
    //   const filtered = prevState.document_ids.filter((item: any) => item.id !== id);
    //   console.log('Filtered Documents:', filtered);

    //   return {
    //     ...prevState,
    //     document_ids: filtered,
    //   };
    // });
  };

  const handleUploadDocuments = async (e: any) => {
    setUploadLoading(true);
    try {
      for (const item of Array.from(e)) {
        const formData = new FormData();
        formData.append("file", item as any);

        const resp = await clientAdminFileUpload(formData); // waits here

        if (resp) {
          getValue(selfCompliance, `document_ids`, "").push(
            getValue(resp, `data`, {}),
          );
          setSelfCompliance({ ...selfCompliance });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setUploadLoading(false);
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => { };

  const getSpecificPermissions = (permission: string) => {
    switch (permission) {
      case "my-task":
        return "activities_self_compliance_executor_task";
      case "pending-approval":
        return "activities_self_compliance_evaluator_approval";
      case "approved-task":
        return "activities_self_compliance_completed_task";
      case "master":
        return "repository_mapped_checkpoint_master";
      case "function-head":
        return "repository_mapped_checkpoint_function_head";
      case "evaluator":
        return "repository_mapped_checkpoint_evaluator";
      case "pending-audit":
        return "audit_compliance_audit_pending";
      case "completed-audit":
        return "audit_compliance_audit_completed";
      default:
        return null;
    }
  };

  const getUserPermission = (permission: string, data: any) => {
    switch (permission) {
      case "my-task":
        return getValue(data, `executor.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;
      case "pending-approval":
        return getValue(data, `evaluator.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;

      case "function_head":
        return getValue(data, `function_head.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;
      default:
        return true;
    }
  };
  let route = window.location.pathname.split("/");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  /* -------------------------------------------------------------------------- */
  /*                           New Upload Reports                               */
  /* -------------------------------------------------------------------------- */
  const [updateUploadLoading, setUpdateUploadLoading] = useState(false);
  const handleUpdateUploadDocuments = async () => {
    try {
      let ids = getValue(selfCompliance, `document_ids`, []).filter(
        (item: object) => getValue(item, `key`, ""),
      );
      setUpdateUploadLoading(true);
      let resp = await SelfComplainceTaskUploadDocument(
        getValue(mainParams, `id`, ""),
        {
          document_ids:
            getValue(ids, `length`, 0) > 0
              ? ids.map((item: object) => ({
                id: getValue(item, `id`, ""),
              }))
              : [],
        },
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSubmitLoading(false);
        setShowUpdatePopup(false);
        setSelfCompliance({
          ...selfCompliance,
          completion_date: "",
          compliance_status: "",
          work_status: "",
          remarks: "",
          non_compliance_reason: "",
          event_not_occured: false,
          document_ids: [],
        });
        setUpdateUploadLoading(false);
        getData();
      } else {
        setUpdateUploadLoading(false);
      }
    } catch (error) {
      setUpdateUploadLoading(false);
    }
  };

  const handleUpdateUploadDocumentsSubmit = async () => {
    try {
      let ids = getValue(selfCompliance, `document_ids`, []).filter(
        (item: object) => getValue(item, `key`, ""),
      );
      setUpdateUploadLoading(true);
      let resp = await SelfComplainceTaskUploadDocument(
        getValue(mainParams, `id`, ""),
        {
          document_ids:
            getValue(ids, `length`, 0) > 0
              ? ids.map((item: object) => ({
                id: getValue(item, `id`, ""),
              }))
              : [],
        },
      );
      if (resp) {
        // toast.success(getValue(resp, `message`, ""));
        setSubmitLoading(false);
        setShowUpdatePopup(false);
        setSelfCompliance({
          ...selfCompliance,
          completion_date: "",
          compliance_status: "",
          work_status: "",
          remarks: "",
          non_compliance_reason: "",
          event_not_occured: false,
          document_ids: [],
        });
        setUpdateUploadLoading(false);
        getData();
      } else {
        setUpdateUploadLoading(false);
      }
    } catch (error) {
      setUpdateUploadLoading(false);
    }
  };

  const [statusLoading, setStatusLoading] = useState(false);
  const handleChangeUpdateStatus = async () => {
    try {
      setStatusLoading(true);
      let resp = await SelfComplainceUpdateStatusToReportedNonComplied(
        getValue(mainParams, `id`, ""),
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setStatusLoading(false);
        setShowUpdatePopup(false);
        setSelfCompliance({
          ...selfCompliance,
          completion_date: "",
          compliance_status: "",
          work_status: "",
          remarks: "",
          non_compliance_reason: "",
          event_not_occured: false,
          document_ids: [],
        });
        getData();
      } else {
        setStatusLoading(false);
      }
    } catch (error) {
      setStatusLoading(false);
    }
  };

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmModal = () => {
    setConfirmOpen(!confirmOpen);
  };

  // const handleSubmitConfirmModalTask = async () => {
  //   let url = window.location.pathname.split("/");
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const completionDate = new Date(
  //     getValue(selfCompliance, `completion_date`, "")
  //   );
  //   const legalDueDate = new Date(getValue(data, `legal_due_date`, ""));
  //   const currentDate = new Date();

  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     ...params,
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   if (getValue(selfCompliance, `completion_date`, "")) {
  //     try {
  //       let obj = JSON.parse(JSON.stringify(selfCompliance));
  //       // const completionDateUTC = new Date(obj["completion_date"]);
  //       // const istDate = new Date(
  //       //   completionDateUTC.getTime() + 5.5 * 60 * 60 * 1000
  //       // );
  //       // obj["completion_date"] = `${istDate.getFullYear()}-${(
  //       //   istDate.getMonth() + 1
  //       // )
  //       //   .toString()
  //       //   .padStart(2, "0")}-${istDate
  //       //   .getDate()
  //       //   .toString()
  //       //   .padStart(2, "0")}T${istDate
  //       //   .getHours()
  //       //   .toString()
  //       //   .padStart(2, "0")}:${istDate
  //       //   .getMinutes()
  //       //   .toString()
  //       //   .padStart(2, "0")}:${istDate
  //       //   .getSeconds()
  //       //   .toString()
  //       //   .padStart(2, "0")}`;

  //       if (selectedStatus === "COMPLIED" || selectedStatus === "RE_OPENED") {
  //         obj["compliance_status"] = selectedStatus;
  //       } else {
  //         obj["approval_status"] = "APPROVED";
  //       }
  //       obj["document_ids"] =
  //         getValue(selfCompliance, `document_ids.length`, 0) > 0
  //           ? getValue(selfCompliance, `document_ids`, []).map(
  //               (item: object) => ({ id: getValue(item, `id`, "") })
  //             )
  //           : [];

  //       const isDocumentRequired = getValue(
  //         data,
  //         `self_compliance.document_required`,
  //         false
  //       );
  //       const hasRequiredDocuments =
  //         getValue(selfCompliance, `document_ids.length`, 0) > 0;
  //       const eventNotOccurred = getValue(
  //         selfCompliance,
  //         `event_not_occured`,
  //         false
  //       );
  //       const isLateCompletion = completionDate > legalDueDate;
  //       const isLateReporting = currentDate > legalDueDate;

  //       // Check if documents are required but not provided, and event hasn't occurred
  //       if (isDocumentRequired && !hasRequiredDocuments && !eventNotOccurred) {
  //         toast.error("Documents required");
  //       }
  //       // Check if completion date is late and relevant comments are missing (for my-task)
  //       else if (
  //         isLateCompletion &&
  //         route[3] === "my-task" &&
  //         !getValue(selfCompliance, `non_compliance_reason`, "")
  //       ) {
  //         toast.error(
  //           "The Completion Date is greater than Legal Due Date! Please provide your Reason for Non-Compliance"
  //         );
  //       }
  //       // Check for scenarios requiring evaluator comments (exclude RE_OPENED status)
  //       else if (
  //         selectedStatus !== "RE_OPENED" &&
  //         route[3] !== "my-task" &&
  //         !getValue(selfCompliance, `evaluator_comments`, "") &&
  //         (isLateCompletion || isLateReporting)
  //       ) {
  //         let errorMessage = "";

  //         if (isLateCompletion && isLateReporting) {
  //           errorMessage =
  //             "Completion Date and Reported Date are after Legal Due Date! Please provide your comments";
  //         } else if (isLateCompletion) {
  //           errorMessage =
  //             "The Completion Date is after Legal Due Date! Please provide your comments";
  //         } else if (isLateReporting) {
  //           errorMessage =
  //             "The Reported Date is after Legal Due Date! Please provide your comments";
  //         }

  //         toast.error(errorMessage);
  //       } else {
  //         setSubmitLoading(true);
  //         let resp;
  //         if (selectedInterlinkedIds && selectedInterlinkedIds.length > 1) {
  //           obj["self_compliance_task_ids"] = selectedInterlinkedIds;
  //           resp = await UpdateMultipleSelfComplianceTask(obj);
  //         } else {
  //           resp = await UpdateSelfComplianceTask(
  //             getValue(mainParams, `id`, ""),
  //             obj
  //           );
  //         }
  //         if (resp) {
  //           setSelectedInterlinkedIds([]);
  //           toast.success(getValue(resp, `message`, ""));
  //           setSubmitLoading(false);
  //           setShowUpdatePopup(false);
  //           setSelfCompliance({
  //             ...selfCompliance,
  //             completion_date: "",
  //             compliance_status: "",
  //             work_status: "",
  //             remarks: "",
  //             non_compliance_reason: "",
  //             event_not_occured: false,
  //             document_ids: [],
  //           });
  //           navigate(
  //             `/${getValue(url, `[${1}]`, "")}/${getValue(
  //               url,
  //               `[${2}]`,
  //               ""
  //             )}/${getValue(url, `[${3}]`, "")}?${queryRequest}`
  //           );
  //         } else {
  //           setSubmitLoading(false);
  //         }
  //       }
  //     } catch (error) {
  //       setSubmitLoading(false);
  //     }
  //   } else {
  //     toast.error("Completion date is mandatory");
  //   }
  // };
  /* --------------------------------------------------------------------------- */
  /* --------------------------  Auditor Comment  ------------------------------ */
  /* --------------------------------------------------------------------------- */
  const [isACOpen, setIsACOpen] = useState(false);
  const [ACLoading, setACLoading] = useState(false);
  const [requestAC, setRequestAC] = useState({
    auditor_comments: "",
    audit_comment_date: "",
  });
  const handleModalAC = () => {
    setIsACOpen(!isACOpen);
  };

  const handleSubmitAuditorComment = async () => {
    // let IDs = list.filter((item: object) =>
    //   selectedIDs.includes(getValue(item, `id`, ""))
    // );

    // let id = getValue(IDs[0], `id`, null);
    try {
      setACLoading(true);
      let payload: any = {
        audit_comments: getValue(requestAC, `auditor_comments`, ""),
        audit_comment_date: new Date().toISOString(),
      };
      let resp = await updateSelfComplianceAuditorComment(
        mainParams.id,
        payload,
      );
      if (resp) {
        setACLoading(false);
        toast.success(getValue(resp, `message`, ""));
        // getData();
        // handleUpdateTaskAC();
        setIsACOpen(false);

        setData({
          ...data,
          audit_comment: getValue(requestAC, `auditor_comments`, ""),
        });
        setRequestAC({
          ...requestAC,
          auditor_comments: "",
          audit_comment_date: "",
        });
        // setSubmissionComplete(true);
      } else {
        setACLoading(false);
      }
    } catch (error) {
      setACLoading(false);
    }
  };

  return (
    <>
      <div className="master-inner-details-grey-bg">
        <Layout>
          {getValue(params, `request_from`, "") !== "MASTER" &&
            !loading &&
            !getValue(props, `subTabPermissionList`, []).includes(
              getSpecificPermissions(route[3]),
            ) ? (
            <NoAccessPage />
          ) : (
            <>
              {loading || !props.permissionAPITriggered ? (
                <Loader />
              ) : !getUserPermission(route[3], data) ? (
                <NoAccessPage />
              ) : (
                <div className="master-details-page-main">
                  <SelfComplianceTaskNavigation
                    id={mainParams.id}
                    checkpoint_id={mainParams.checkpoint_id}
                    permissions={props.permissions}
                    handleClickPopup={handleClickPopup}
                    showTaskInfo
                    params={mainParams}
                    status={
                      getValue(data, `approval_status`, "") === "APPROVED"
                        ? getValue(data, `approval_status`, "")
                        : getValue(data, `compliance_status`, "")
                    }
                    global_route={route[1]}
                    parent_route={route[2]}
                    main_route={route[3]}
                  />
                  <div className="map-vendor-wrapper map-vendor-wrapper--task-details w-100">
                    <div className="map-vendor__details map-vendor__details--task-details d-flex align-items-flex-start px-0 my-0">
                      <>
                        <TaskDetailsCommon
                          data={getValue(data, `self_compliance`, {})}
                          documentStore={docStoreData}
                          interlinkedTaskList={interlinkedTaskList}
                        />
                        <OrganizationInformationCommon
                          data={data}
                          headerObj={headerObj}
                          getData={getData}
                          permissions={getValue(props, `permissions`, [])}
                          {...mainParams}
                        />
                      </>
                    </div>
                    <div className="w-100 footer-wrapper--task d-none">
                      <img
                        src="/images/footer-image.svg"
                        className="img-fluid footer-image"
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <SelfComplianceUpdatePopup
            showUpdatePopup={showUpdatePopup}
            setShowUpdatePopup={setShowUpdatePopup}
            setSelfCompliance={setSelfCompliance}
            selfCompliance={selfCompliance}
            handleUploadDocuments={handleUploadDocuments}
            handleSubmitTask={handleSubmitTask}
            submitLoading={submitLoading}
            complianceStatusList={complianceStatusList}
            parent_route={route[1]}
            main_route={route[3]}
            sub_route={route[3]}
            removeDocument={removeDocument}
            selectedStatus={selectedStatus}
            selectedObj={data}
            uploadLoading={uploadLoading}
            handleDrop={handleDrop}
            handleDragOver={handleDragOver}
            disableUpload={disableUpload}
            permissions={getValue(props, `permissions`, [])}
            params={params}
            // type={"pending_approval"}
            type={
              route[3] === "my-task" ? "executor-tasks" : "pending_approval"
            }
            updateUploadLoading={updateUploadLoading}
            handleUpdateUploadDocuments={handleUpdateUploadDocuments}
            showUploadUpdate={route[3] === "approved-task" ? true : false}
            // showUploadUpdate
            handleChangeUpdateStatus={handleChangeUpdateStatus}
            statusLoading={statusLoading}
            inside={true}
            // showAuditorComment
            showAuditorComment={
              route[1] === "repository" && route[2] === "mapped-checkpoint"
            }
            handleModalAC={handleModalAC}
            handleUpdateUploadDocumentsSubmit={
              handleUpdateUploadDocumentsSubmit
            }
            handleUploadSubmitTask={handleUploadSubmitTask}
            interlinkedTaskList={interlinkedTaskList}
          />
          <ConfirmModalTask
            isOpen={confirmOpen}
            handleModal={handleConfirmModal}
            handleSubmit={handleSubmitConfirmModalTask}
          />
          <AuditorCommentModal
            isACOpen={isACOpen}
            requestAC={requestAC}
            setRequestAC={setRequestAC}
            handleModalAC={handleModalAC}
            handleSubmitAuditorComment={handleSubmitAuditorComment}
            selectedAuditorComments={getValue(data, `audit_comment`, "")}
          />
        </Layout>
      </div>
    </>
  );
}
